var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SubSectionModules"},[_c('h3',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('Row',_vm._l((_vm.modules),function(module,index){return _c('Column',{key:index,attrs:{"sm":6,"xs":12}},[_c('ColumnModule',{attrs:{"module":module}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }